import { withStyles } from "@material-ui/core";
import Details from "./Details";
import ClosingSoonBadge from "../../../../Common/ClosingSoonBadge";
import React from "react";
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../../../appConfigContext";
const styles = (theme) => ({
  container: {
    display: "flex",
    color: theme.TextColor,
    alignItems: "center",
  },
  spacing: {
    marginRight: 8,
  },
});
@inject("DispatchStore")
@observer
class Label extends React.PureComponent {
  render() {
    const {
      data,
      classes,
      pickupId,
      configJSON: { closingSoonWarningTimeLimit, closingSoonAlertTimeLimit }
    } = this.props;
    const closingSoonTime = this.props.DispatchStore.pickupIdToClosingTimeMapping[pickupId.toUpperCase()]
    const closingSoonLimitConfig = {
      closingSoonWarningTimeLimit,
      closingSoonAlertTimeLimit
    }
    return (
      <div className={classes.container}>
        <Details containerClass={classes.spacing} label="Pickup# : " value={data.pickup.number} />
        <Details
          containerClass={classes.spacing}
          label="Shipper : "
          value={`${data.shipper.name} (${data.shipper.accountNumber}) | ${data.shipper.address}`}
        />
        {data.driver.id && (
          <Details
            containerClass={classes.spacing}
            label="Driver : "
            value={`${data.driver.name} (${data.driver.number})`}
          />
        )}
        <ClosingSoonBadge
          closingSoonLimitConfig={closingSoonLimitConfig}
          timeToCloseInMins={closingSoonTime}
        />
      </div>
    );
  }
}

export default compose(withAppConfig, withStyles(styles))(Label);
